import { render } from "./PlanNavIcon.vue?vue&type=template&id=c8582bcc"
import script from "./PlanNavIcon.vue?vue&type=script&lang=js"
export * from "./PlanNavIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__